import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styled from "styled-components";
import fetchClient from "../../api/fetchClient";
import Loader from "../../components/Loader";
import { ArrowBack, AccountBalance, Description, Search, NavigateNext, NavigateBefore } from "@material-ui/icons";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { v4 as uuidv4 } from "uuid";
import Concur from './Concur';
import {
    Container,
    ModernHeader,
    HeaderLeft,
    HeaderContent,
    PageTitle,
    PageSubtitle,
    HeaderActions,
    BackButton,
    NewButton,
    ResultsCard,
    SectionInfo,
    SectionInfoTitle,
    SectionSubtitle,
    TableWrapper,
    StreamsTable,
    TableHead,
    TableRow,
    TableCell,
    TableActions,
    ActionButton,
    EmptyState,
    EmptyTitle,
    EmptyText,
    getTheme,
} from "../../components/common";

export default function ConcurPage() {
    const history = useHistory();
    const theme = getTheme('concur');
    const [concurs, setConcurs] = useState([])
    const [isViewingConcur, setIsViewingConcur] = useState(false)
    const [hasNext, setHasNext] = useState(false)
    const [viewingConcur, setViewingConcur] = useState(null)
    const [Searchs, setSearchs] = useState({})
    const [Index, setIndex] = useState(0)
    const [isLoading, setIsLoading] = useState(true)

    // Filter state
    const [searchTerm, setSearchTerm] = useState('')

    // Pagination state for records per page
    const [recordsPerPage, setRecordsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    // Filtered data
    const filteredConcurs = useMemo(() => {
        if (!searchTerm) return concurs
        const term = searchTerm.toLowerCase()
        return concurs.filter(item => {
            const idMatch = item.id && item.id.toLowerCase().includes(term)
            const nameMatch = item.name && item.name.toLowerCase().includes(term)
            const descMatch = item.description && item.description.toLowerCase().includes(term)
            return idMatch || nameMatch || descMatch
        })
    }, [concurs, searchTerm])

    // Paginated data
    const paginatedConcurs = useMemo(() => {
        const startIndex = (currentPage - 1) * recordsPerPage
        const endIndex = startIndex + recordsPerPage
        return filteredConcurs.slice(startIndex, endIndex)
    }, [filteredConcurs, currentPage, recordsPerPage])

    const totalPages = Math.ceil(filteredConcurs.length / recordsPerPage)

    // Reset to first page when filters change
    useEffect(() => {
        setCurrentPage(1)
    }, [searchTerm, recordsPerPage])

    const getConcurs = async (type = null) => {

        const searchs = Searchs;
        var index = Index
        var token = null

        if (type === 'sum') {
            token = searchs[index].next
            index++;
        } else if (type === 'diff') {
            token = searchs[index].previous
            index--;
        } else {
            index = 0;
        }

        try {
            setIsLoading(true)
            const { data } = await fetchClient.get(`getAllConcur${token ? `?nextToken=${token}` : ''}`);

            if (data.nextToken) setHasNext(true)
            else setHasNext(false)
            setSearchs({
                [index]: {
                    next: data.nextToken,
                    previous: index > 0 ? searchs[index - 1].token : null,
                    token: token
                },
                ...Searchs
            })
            setIndex(index)
            console.log(data)
            setConcurs(data.value);
        } catch (err) {
            console.log(err);
            alert('Erro ao carregar aplicações');
        } finally {
            setIsLoading(false);
        }
    }

    const viewConcur = async (concur) => {
        setIsViewingConcur(true);
        setViewingConcur(concur);
        console.log('shwing concur')
    }

    useEffect(() => {
        getConcurs();
        //eslint-disable-next-line
    }, [isViewingConcur])

    return (
        <Container>
            {isViewingConcur ? (
                <Concur
                    data={viewingConcur}
                    isViewing={setIsViewingConcur}
                />
            ) : (
                <>
                    <ModernHeader>
                        <HeaderLeft>
                            <BackButton color={theme.primary} onClick={() => history.goBack()}>
                                <ArrowBack />
                            </BackButton>
                            <HeaderContent>
                                <PageTitle>
                                    <AccountBalance style={{ marginRight: '12px', fontSize: '32px' }} />
                                    Configurações Concur
                                </PageTitle>
                                <PageSubtitle>Gerencie as configurações do Concur</PageSubtitle>
                            </HeaderContent>
                        </HeaderLeft>
                        <HeaderActions>
                            <NewButton
                                gradient={theme.gradient}
                                onClick={() => viewConcur({ id: uuidv4(), newConcur: true })}
                            >
                                <PersonAddIcon style={{ marginRight: '8px' }} />
                                Nova Configuração
                            </NewButton>
                        </HeaderActions>
                    </ModernHeader>

                    {isLoading ? (
                        <LoaderWrapper>
                            <Loader />
                        </LoaderWrapper>
                    ) : concurs.length === 0 ? (
                        <ResultsCard>
                            <EmptyState>
                                <Description style={{ fontSize: '48px', color: '#cbd5e1', marginBottom: '16px' }} />
                                <EmptyTitle>Nenhuma configuração encontrada</EmptyTitle>
                                <EmptyText>Não há configurações cadastradas no sistema. Adicione uma nova configuração para começar.</EmptyText>
                            </EmptyState>
                        </ResultsCard>
                    ) : (
                        <ResultsCard>
                            <SectionInfoWrapper>
                                <SectionInfoLeft>
                                    <SectionInfoTitle>Configurações cadastradas</SectionInfoTitle>
                                    <SectionSubtitle>
                                        Mostrando {paginatedConcurs.length} de {filteredConcurs.length} {filteredConcurs.length === 1 ? 'configuração' : 'configurações'}
                                        {searchTerm && ` (filtrado de ${concurs.length})`}
                                    </SectionSubtitle>
                                </SectionInfoLeft>
                                <SearchContainer>
                                    <SearchIcon>
                                        <Search style={{ fontSize: '20px' }} />
                                    </SearchIcon>
                                    <SearchInput
                                        type="text"
                                        placeholder="Pesquisar por ID, nome ou descrição..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    {searchTerm && (
                                        <ClearSearchButton onClick={() => setSearchTerm('')}>
                                            ×
                                        </ClearSearchButton>
                                    )}
                                </SearchContainer>
                            </SectionInfoWrapper>

                            <TableWrapper>
                                <StreamsTable>
                                    <thead>
                                        <tr>
                                            <TableHead>ID</TableHead>
                                            <TableHead>Nome</TableHead>
                                            <TableHead>Descrição</TableHead>
                                            <TableHead align="right">Ações</TableHead>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedConcurs.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={4} style={{ textAlign: 'center', color: '#6b7280' }}>
                                                    Nenhum resultado encontrado para os filtros aplicados
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            paginatedConcurs.map((item) => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item.id}</TableCell>
                                                    <TableCell>{item.name}</TableCell>
                                                    <TableCell>{item.description}</TableCell>
                                                    <TableActions>
                                                        <ActionButton
                                                            gradient={theme.gradient}
                                                            onClick={() => viewConcur(item)}
                                                        >
                                                            <Search style={{ marginRight: '6px', fontSize: '18px' }} />
                                                            Visualizar
                                                        </ActionButton>
                                                    </TableActions>
                                                </TableRow>
                                            ))
                                        )}
                                    </tbody>
                                </StreamsTable>
                            </TableWrapper>

                            <PaginationWrapper>
                                <RecordsPerPageContainer>
                                    <RecordsPerPageLabel>Registros por página:</RecordsPerPageLabel>
                                    <RecordsPerPageSelect
                                        value={recordsPerPage}
                                        onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </RecordsPerPageSelect>
                                </RecordsPerPageContainer>

                                <PaginationContainer>
                                    <PaginationButton
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    >
                                        <NavigateBefore />
                                    </PaginationButton>
                                    <PageIndicator>
                                        Página {currentPage} de {totalPages || 1}
                                    </PageIndicator>
                                    <PaginationButton
                                        disabled={currentPage >= totalPages}
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    >
                                        <NavigateNext />
                                    </PaginationButton>
                                </PaginationContainer>

                                <LoadMoreContainer>
                                    {hasNext && (
                                        <LoadMoreButton
                                            gradient={theme.gradient}
                                            onClick={() => getConcurs('sum')}
                                        >
                                            Carregar mais registros
                                        </LoadMoreButton>
                                    )}
                                    {Index > 0 && (
                                        <LoadMoreButton
                                            gradient={theme.gradient}
                                            onClick={() => getConcurs('diff')}
                                            style={{ marginLeft: '8px' }}
                                        >
                                            Voltar página anterior
                                        </LoadMoreButton>
                                    )}
                                </LoadMoreContainer>
                            </PaginationWrapper>
                        </ResultsCard>
                    )}
                </>
            )}
        </Container>
    );
}

// ===== COMPONENTES ESPECÍFICOS DESTA PÁGINA =====

const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    width: 100%;
    box-sizing: border-box;
`;

const PaginationContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
`;

const PaginationButton = styled.button`
    width: 40px;
    height: 40px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(142, 68, 173, 0.3);

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(142, 68, 173, 0.4);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        background: #bdbdbd;
        cursor: not-allowed;
        box-shadow: none;
    }
`;

const PageIndicator = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    font-family: 'Mulish', sans-serif;
    padding: 0 16px;
`;

// ===== SEARCH COMPONENTS =====

const SectionInfoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    padding: 24px 16px 0 16px;
    gap: 16px;
`;

const SectionInfoLeft = styled.div`
    display: flex;
    flex-direction: column;
`;

const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    min-width: 300px;
`;

const SearchIcon = styled.div`
    position: absolute;
    left: 12px;
    color: #9ca3af;
    display: flex;
    align-items: center;
    pointer-events: none;
`;

const SearchInput = styled.input`
    width: 100%;
    padding: 10px 40px 10px 44px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #8e44ad;
        box-shadow: 0 0 0 3px rgba(142, 68, 173, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`;

const ClearSearchButton = styled.button`
    position: absolute;
    right: 8px;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    background: #e5e7eb;
    color: #6b7280;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background: #d1d5db;
        color: #374151;
    }
`;

// ===== PAGINATION COMPONENTS =====

const PaginationWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
`;

const RecordsPerPageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const RecordsPerPageLabel = styled.span`
    font-size: 14px;
    color: #6b7280;
    font-family: 'Mulish', sans-serif;
`;

const RecordsPerPageSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #8e44ad;
    }
`;

const LoadMoreContainer = styled.div`
    display: flex;
    align-items: center;
`;

const LoadMoreButton = styled.button`
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    background: ${props => props.gradient || 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)'};
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;
    box-shadow: 0 2px 8px rgba(142, 68, 173, 0.3);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(142, 68, 173, 0.4);
    }

    &:active {
        transform: translateY(0);
    }
`;
